(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealCategoryCards() {
      var items = document.querySelectorAll('[data-pyp-cat-reveal]:not(.pyp-cat-in-view)');
      if (!items.length) return;

      if (prefersReducedMotion || !('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('pyp-cat-in-view'); });
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pyp-cat-in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -30px 0px' });

      items.forEach(function (el) { observer.observe(el); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealCategoryCards);
    } else {
      revealCategoryCards();
    }
    document.addEventListener('shopify:section:load', revealCategoryCards);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
